import React from "react";
import { Icon } from "@iconify/react";
import locationIcon from "@iconify/icons-mdi/directions-car";
import "./map.css";

const LocationPin = () => (
  <div className="pin">
    <Icon icon={locationIcon} className="pin-icon" />
  </div>
);

export default LocationPin;
